import React, {Component} from 'react';

import TaoTable from "./TaoTable/TaoTable";
import PainTable from "./PainTable/PainTable";

class AcuTableSwitcher extends Component {

    constructor(props) {
        super(props);

        this.state = {
            selectedTable: "tao"
        };
    }

    setTable = (table) => {
        this.setState({
            selectedTable: table
        });
    };

    render() {
        const { selectedTable } = this.state;

        return (
            <div>

                <div
                    style={{
                        marginTop: 20,
                        marginBottom: 20,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        gap: 10,
                        width: "100%"
                    }}
                >
                    <button
                        onClick={() => this.setTable("tao")}
                        style={{
                            padding: "8px 16px",
                            cursor: "pointer",
                            border:
                                selectedTable === "tao"
                                    ? "2px solid #494475"
                                    : "1px solid #ccc",
                            background:
                                selectedTable === "tao"
                                    ? "#f3f0ff"
                                    : "white",
                            borderRadius: 4
                        }}
                    >
                        Tao tabulka
                    </button>

                    <button
                        onClick={() => this.setTable("pain")}
                        style={{
                            padding: "8px 16px",
                            cursor: "pointer",
                            border:
                                selectedTable === "pain"
                                    ? "2px solid #494475"
                                    : "1px solid #ccc",
                            background:
                                selectedTable === "pain"
                                    ? "#f3f0ff"
                                    : "white",
                            borderRadius: 4
                        }}
                    >
                        Bolest
                    </button>
                </div>

                {selectedTable === "tao" && <TaoTable />}
                {selectedTable === "pain" && <PainTable />}

            </div>
        );
    }
}

export default AcuTableSwitcher